import { z } from 'zod';

export const ChatRole = z.enum(['user', 'assistant', 'system']);
export type ChatRole = z.infer<typeof ChatRole>;

export const ChatMessage = z.object({
  role: ChatRole,
  content: z.string(),
});
export type ChatMessage = z.infer<typeof ChatMessage>;

export const ChatRequest = z.object({
  shop: z.string().min(1).max(64).regex(/^[a-z0-9-]+$/),
  messages: z.array(ChatMessage).min(1).max(40),
});
export type ChatRequest = z.infer<typeof ChatRequest>;

/**
 * Un pezzo di contenuto indicizzabile di un sito editoriale.
 *
 * `id` deve essere stabile tra un crawl e l'altro: è la chiave con cui l'upsert
 * aggiorna invece di duplicare, ed è quella che `/admin/sync/finalize` usa per
 * cancellare ciò che non esiste più. Vectorize limita l'id del vettore a 64
 * byte e il worker ci antepone `<shop>:`, quindi qui il tetto è 48.
 */
export const DocChunk = z.object({
  id: z.string().min(1).max(48),
  url: z.string().url(),
  pageTitle: z.string().min(1),
  sectionTitle: z.string().default(''),
  contentType: z.string().default('page'),
  text: z.string().min(1),
});
export type DocChunk = z.infer<typeof DocChunk>;

export const Product = z.object({
  id: z.string(),
  shop: z.string(),
  title: z.string(),
  description: z.string(),
  price: z.number().nonnegative(),
  currency: z.string().length(3),
  stock: z.number().int(),
  url: z.string().url(),
  attributes: z.record(z.string(), z.string()).default({}),
});
export type Product = z.infer<typeof Product>;
